import React from 'react';
import { Card } from 'antd';
import OrganizationDataTable from './OrganizationDataTable';
import Pagination from '../../Pagination';
import API from '../../../helper/api';

class OrganizationList extends React.Component {
  state = {
    data: '',
    isLoading: true
  };

  saveData = (data, isLoading) => {
    this.setState({ data, isLoading });
  };

  render() {
    const { data, isLoading } = this.state;
    return (
      <Card style={{ marginBottom: '100px' }}>
        <Pagination path={API.organization.list} saveData={this.saveData} />
        {data && <OrganizationDataTable data={data} isLoading={isLoading} />}
      </Card>
    );
  }
}

export default OrganizationList;
